import {
    Icon20ArchiveOutline,
    Icon20DocumentOutline,
    Icon20FolderOutline,
    Icon20MusicOutline,
    Icon20PictureOutline,
    Icon20VideoSquareOutline,
} from '@vkontakte/icons';
import { ChangeEvent, KeyboardEvent, ReactElement, RefObject } from 'react';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

export interface IState {
    active: boolean;
    focus: boolean;
    open: boolean;
    value: string;
    type: string;
}

export enum EActions {
    close = 'close',
    removeType = 'removeType',
    setFocus = 'setFocus',
    setType = 'setType',
    setActive = 'setActive',
    setValue = 'setValue',
    setOpenFilters = 'setOpenFilters',
    toggleFilters = 'toggleFilters',
}

export interface IAction {
    type: EActions;
    payload?: boolean | string;
}

export interface IOption {
    id: string;
    text: string;
    icon: ReactElement;
}

export interface ISearchProps {
    dropdownAvailable?: boolean;
    toggleSearch: (state: boolean) => void;
    isExpanded: boolean;
    onlyExpanded?: boolean;
    storage: EStorageType;
}

export interface ISearchContentProps extends ISearchProps {
    rootRef: RefObject<HTMLElement>;
    dropdownRef: RefObject<HTMLElement>;
    onSearchStateChange: ({ type, payload }: { type: EActions; payload?: any }) => void; // использовали только для тултипов reactApp/ui/Header/SearchTooltip/SearchTooltip.tsx
}

export interface ISearchContent {
    isFocus: boolean;
    isOpen: boolean;
    value: string;
    searchOption: IOption;
    placeholder: string;
    onSearchClick: () => void;
    onInputClick: () => void;
    onDocumentClick: (event: Event) => void;
    onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onInputClear: () => void;
    onKeyUp: (event: KeyboardEvent) => void;
    onToggleFilters: () => void;
    setActiveInput: () => void;
    chooseSearchType: (type: string) => void;
    removeSearchType: () => void;
    removeFocus: () => void;
}

export const typesOptions = {
    image: {
        id: 'image',
        text: 'Изображения',
        icon: Icon20PictureOutline,
    },
    document: {
        id: 'document',
        text: 'Документы',
        icon: Icon20DocumentOutline,
    },
    audio: {
        id: 'audio',
        text: 'Музыка',
        icon: Icon20MusicOutline,
    },
    video: {
        id: 'video',
        text: 'Видео',
        icon: Icon20VideoSquareOutline,
    },
    folder: {
        id: 'folder',
        text: 'Папки',
        icon: Icon20FolderOutline,
    },
    archive: {
        id: 'archive',
        text: 'Архивы',
        icon: Icon20ArchiveOutline,
    },
} as const;

export const typesOptionsList = Object.values(typesOptions);
